<template>
  <div class="page">
    <Sticky>
      <Header></Header>
      <div class="main">
        <p class="company">{{ $t('appointment.visitors.company') }}</p>
        <p class="record">{{ $t('appointment.visitors.record.search') }}</p>
      </div>
      <div class="search">
        <Search v-model="value" :placeholder="$t('appointment.visitors.record.phone.tips')" @input="input">
          <div class="icon" slot="left-icon">
            <Iconfont name="iconhuiyiH5sousuotubiao" className="icon"></Iconfont>
          </div>
          <!-- <div class="icon" slot="right-icon">
            <Iconfont name="iconwenziqingkongdel" className="icon"></Iconfont>
          </div> -->
        </Search>
        <span v-if="isSearch" class="cancel" @click="search">{{ $t('option.proceed.search') }}</span>
        <span class="none" v-else></span>
      </div>
    </Sticky>
    <div v-if="!!list.length && value" class="section">
      <div class="container">
        <div class="top">
          <span>{{ '【' }}</span>
          <span>{{ value }}</span>
          <span>{{ '】' }}</span>
          <span>{{ $t('appointment.visitors.record.person') }}</span>
        </div>
        <FormItem v-for="item in list" :key="item" :value="item" />
      </div>
    </div>
    <Empty v-else :context="$t('appointment.visitors.record.none.tips')" :img="image" />
  </div>
</template>

<script>
// import Input from '@/components/input.vue';
import Header from '@/components/header.vue';
import { Search, Sticky, Notify } from 'vant';
import Iconfont from '@/components/icon';
import Empty from './empty';
import image from '@/assets/img/emptySearch.png';
import FormItem from './formItem';
import api from '@/services/api';

export default {
  components: {
    // Input,
    Header,
    Search,
    Iconfont,
    Empty,
    FormItem,
    Sticky,
  },
  data() {
    return {
      value: '',
      image,
      list: [],
      isSearch: false,
    };
  },
  computed: {
    showList() {
      const regxp = new RegExp(this.value);
      return this.list.filter(item => regxp.test(item.personName));
    },
    // isSearch() {
    //   this.value !== '';
    // },
  },
  methods: {
    input(val) {
      this.isSearch = val ? true : false;
      this.list = val ? this.list : [];
    },
    auth() {
      if (this.value) {
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(this.value)) {
          Notify({
            type: 'warning',
            message: this.$t('visitor.apply.phone.error.tips'),
          });
          return false;
        }
      }
      return true;
    },
    async search() {
      if (!this.auth()) return;
        // Toast.loading({
        //   duration: 0,
        //   forbidClick: true,
        //   message: this.$t('empty.loading') + '...',
        // });
      // const res = await api.getPublicResource('./json/record.json');
      // if (res) {
      //   this.list = res.data;
      // }
      const [status, res] = await api.getRecordSearchList({
        params: {
          phone: this.value,
        },
      });

      if (!status) return;
      this.list = res.data.list;
    },
  },
  watch: {},
  created() {},
};
</script>

<style lang="less" scoped>
.page {
  overflow: hidden;
  .section {
    margin-top: 32px;
    margin-bottom: 160px;
    padding: 0 30px;
    .container {
      min-height: 100%;
      .top {
        background: #ffffff;
        padding-left: 20px;
        height: 80px;
        line-height: 80px;
        font-size: 24px;
        color: #949aa4;
        text-align: left;
      }
    }
  }
  .search {
    padding: 0 30px;
    width: 100%;
    background: #f7f9fa;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.015);
    .cancel {
      font-size: 32px;
      color: #3d424d;
      flex: 0 0 114px;
      margin-right: 42px;
    }
  }
  .none {
    flex: 0 0 30px;
    margin-right: 30px;
  }
  .van-field__clear {
    font-size: 16px;
    padding: 0;
    margin-right: 16px !important;
  }
  .van-field__body {
    // line-height: 36px;
    display: flex;
    align-items: center;
    padding-right: 8px;
  }
  .van-search__content {
    padding-left: 0;
  }

  .van-search {
    flex: auto;
    // width: calc(100% - 30px);
    background: rgba(142, 145, 147, 0.1);
    padding: 14px 12px 14px 30px;
    border-radius: 8px;
    .van-cell {
      background: rgba(142, 145, 147, 0.1);
      padding: 0;
      //   line-height: 19px;
      //   height: 19px;
      //   input {
      //     height: 19px;
      //     line-height: 19px;
      //   }
    }
  }
  .van-field__left-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .main {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f7f9fa;
    .company {
      font-family: PingFangSC-Regular;
      font-size: 30px;
      color: #949aa4;
      line-height: 36px;
    }
    .record {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #949aa4;
      line-height: 36px;
      margin-top: 16px;
    }
  }
}
</style>
